// src/components/IdealCandidateView/components/PotentialCandidatesTable.js
import React from 'react';
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Chip, Link, Checkbox, useTheme, Tooltip, IconButton } from '@mui/material';
import moment from "moment";
import EventIcon from '@mui/icons-material/Event';
import { motion } from 'framer-motion';

const formatPhoneNumber = (str) => /^\+1\d{10}$/.test(str) ? str.replace(/^(\+1)(\d{3})(\d{3})(\d{4})$/, "$1 ($2) $3-$4") : str;
const scoreToColor = (score) => {
  const numericScore = Number(score);
  if (isNaN(numericScore)) return '#808080';
  return numericScore <= 0.5 ? "#D0312D" : numericScore <= 0.75 ? "#FC6A03" : "#028A0F";
};
const statusLabel = (s) => ({ approved: "Approved", pending: "Pending", declined: "Declined" }[s] || "Unknown");
const statusColor = (s) => ({ approved: "success", pending: "primary", declined: "error" }[s] || "warning");

export default function PotentialCandidatesTable({
  candidates,
  onCandidateClick,
  selectedIds,
  onSelectOne,
  onSelectAll,
  onSchedule,
}) {
  const theme = useTheme();
  const numSelected = selectedIds.length;
  const rowCount = candidates.length;

  return (
    <TableContainer component={Paper} elevation={0} sx={{ mt: 2, borderRadius: 2, border: 1, borderColor: 'divider', maxHeight: 'calc(100vh - 450px)' }}>
      <Table stickyHeader aria-label="sticky table">
        <TableHead>
          <TableRow>
            <TableCell padding="checkbox">
              <Checkbox
                color="primary"
                indeterminate={numSelected > 0 && numSelected < rowCount}
                checked={rowCount > 0 && numSelected === rowCount}
                onChange={onSelectAll}
              />
            </TableCell>
            {["Name", "Email", "Phone", "Applied At", "Skill Score", "Behavior Score", "Status", ""].map((h) => (<TableCell key={h}>{h}</TableCell>))}
          </TableRow>
        </TableHead>
        <TableBody>
          {candidates.map((pc) => {
            const isSelected = selectedIds.includes(pc.id);
            const skillScore = pc.scorecardResults.find((s) => s.scorecardName === "skills")?.score;
            const behaviorScore = pc.scorecardResults.find((s) => s.scorecardName === "behaviors")?.score;
            const skillColor = scoreToColor(skillScore);
            const behaviorColor = scoreToColor(behaviorScore);
            return (
              <TableRow
                key={pc.id}
                hover
                onClick={(event) => onSelectOne(event, pc.id)}
                role="checkbox"
                aria-checked={isSelected}
                tabIndex={-1}
                selected={isSelected}
              >
                <TableCell padding="checkbox">
                  <Checkbox color="primary" checked={isSelected} />
                </TableCell>
                <TableCell><Link component="button" onClick={(e) => { e.stopPropagation(); onCandidateClick(pc.candidate?.email); }}>{pc.candidate.name}</Link></TableCell>
                <TableCell>{pc.candidate.email}</TableCell>
                <TableCell>{formatPhoneNumber(pc.candidate.phone)}</TableCell>
                <TableCell>{moment.unix(pc.createdAt).fromNow()}</TableCell>
                <TableCell align="center"><Chip label={`${Math.round(skillScore * 100)}%`} sx={{ bgcolor: skillColor, color: theme.palette.getContrastText(skillColor) }} /></TableCell>
                <TableCell align="center"><Chip label={`${Math.round(behaviorScore * 100)}%`} sx={{ bgcolor: behaviorColor, color: theme.palette.getContrastText(behaviorColor) }} /></TableCell>
                <TableCell align="center"><Chip label={statusLabel(pc.status)} color={statusColor(pc.status)} /></TableCell>
                <TableCell align="center">
                  <Tooltip title="Schedule Interview">
                    <IconButton onClick={(e) => { e.stopPropagation(); onSchedule(pc); }}>
                      <motion.div whileHover={{ scale: 1.2, rotate: 15 }} transition={{ type: "spring", stiffness: 400, damping: 10 }}>
                        <EventIcon />
                      </motion.div>
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}